import { useQuery } from '@tanstack/react-query';

import { campaignsClient } from 'clients/CampaignsClient/CampaignsClient';
import { QueryKey } from 'types/query';
import { useIsRjCommunicationHubEnabled } from './useIsRjCommunicationHubEnabled';

export const rjBulkUsageQueryKey = [QueryKey.useGetRjBulkUsageQuery] as const;

export const useGetRjBulkUsageQuery = () => {
  const isRjHubFeatureEnabled = useIsRjCommunicationHubEnabled();

  const query = useQuery(
    rjBulkUsageQueryKey,
    async () => {
      const { data } = await campaignsClient.getRjBulkUsage();
      return data;
    },
    {
      staleTime: 60 * 1000,
      enabled: isRjHubFeatureEnabled,
    },
  );

  return {
    ...query,
    used: query.data?.sent_count ?? 0,
    total: query.data?.daily_rj_bulk_activation_limit ?? 0,
    remaining: Math.max(0, (query.data?.daily_rj_bulk_activation_limit ?? 0) - (query.data?.sent_count ?? 0)),
  };
};
